var d = (i, p, t) => new Promise((c, e) => {
  var r = (o) => {
    try {
      a(t.next(o));
    } catch (m) {
      e(m);
    }
  }, s = (o) => {
    try {
      a(t.throw(o));
    } catch (m) {
      e(m);
    }
  }, a = (o) => o.done ? c(o.value) : Promise.resolve(o.value).then(r, s);
  a((t = t.apply(i, p)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import y from "./closeItem.vue.js";
import { defineComponent as C, useTemplateRef as _, computed as v, openBlock as w, createBlock as x, withCtx as f, createVNode as u } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as I } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as n } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import g from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import N from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import k from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const $ = /* @__PURE__ */ C({
  __name: "closeIndex.ce",
  props: {
    type: { default: "", type: null },
    orderId: { default: "", type: null },
    show: { default: "close", type: null },
    theme: { default: "orange", type: String }
  },
  emits: ["confirm", "cancal"],
  setup(i, { expose: p, emit: t }) {
    const c = _("closeIndex"), e = i, r = {
      orange: "#FC9153",
      blue: "#2980ff"
    }, s = I(), a = v(() => ({
      common: {
        primaryColor: r[e.theme],
        primaryColorHover: r[e.theme],
        primaryColorPressed: r[e.theme],
        primaryColorSuppl: r[e.theme]
      }
    })), o = t, m = (l) => {
      o("confirm", l);
    }, h = () => {
      o("cancal");
    };
    return p({ init: () => d(this, null, function* () {
      var l;
      yield (l = c.value) == null ? void 0 : l.init();
    }) }), (l, S) => (w(), x(n(k), {
      locale: n(g),
      "date-locale": n(N),
      "theme-overrides": a.value,
      "style-mount-target": n(s)
    }, {
      default: f(() => [
        u(n(P), { to: n(s) }, {
          default: f(() => [
            u(y, {
              ref_key: "closeIndex",
              ref: c,
              onConfirm: m,
              onCancal: h,
              type: e.type,
              orderId: e.orderId,
              show: e.show
            }, null, 8, ["type", "orderId", "show"])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "theme-overrides", "style-mount-target"]));
  }
});
export {
  $ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/close-form/closeIndex.ce.vue2.js
// module id = 1185
// module chunks = 41